import { Backdrop, Box, IconButton, Modal } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import ReactPlayer from 'react-player'
interface IVideoDialogProps {
    onCloseVideoDialog?: () => void;
    showDialog: boolean;
    videoUrl: any;
}

export const VideoDialog = (props: IVideoDialogProps) => {
    const { showDialog, onCloseVideoDialog, videoUrl } = props

    const handleOnDialogClose = () => {
        onCloseVideoDialog && onCloseVideoDialog()
    };
    
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={showDialog}
            onClose={handleOnDialogClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                }
            }}
            sx={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
            <Box sx={{
                borderRadius: "8px",
                position: 'relative',
                maxWidth: "60vw",
                maxHeight: "90vh",
                overflow: "auto"
            }}>
                <IconButton
                    onClick={handleOnDialogClose}
                    style={{ position: 'absolute', top: 10, right: 10, zIndex: 1 }}>
                    <CloseIcon />
                </IconButton>
                <ReactPlayer
                    url={videoUrl}
                    controls
                    width="100%"
                    height="100%"
                    style={{ borderRadius: "8px" }}
                    playsinline
                    playing
                />
            </Box>
        </Modal>
    )
}